import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/** Approve/reject confirmation with an optional note. */
export function DecisionDialog({
  open,
  approve,
  title,
  description,
  busy,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  approve: boolean;
  title: string;
  description: string;
  busy: boolean;
  onCancel: () => void;
  onConfirm: (note: string) => void;
}) {
  const [note, setNote] = useState('');
  return (
    <AlertDialog
      open={open}
      onOpenChange={(o) => {
        if (!o) {
          setNote('');
          onCancel();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <label className="block space-y-1.5">
          <span className="text-xs font-medium text-gray-600">Note {approve ? '(optional)' : '(recommended)'}</span>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={2}
            className="w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-none ring-blue-500 focus:ring-2"
          />
        </label>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={busy}
            className={approve ? undefined : 'bg-red-600 hover:bg-red-700'}
            onClick={(e) => {
              e.preventDefault();
              onConfirm(note.trim());
              setNote('');
            }}
          >
            {busy && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}
            {approve ? 'Approve' : 'Reject'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
